import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {useIntl} from 'react-intl';

import {Descriptions, Divider, Drawer, Tag} from 'antd';
import {calculateAge, periodTimeText} from 'utils/Utils';

const DiagnosticInfo = (props) => {
  const intl = useIntl();

  const {request, viewing, setViewing} = props;

  const onClose = () => {
    setViewing(false);
  };

  return (
    <Drawer
      title={intl.messages['common.detail']}
      width={800}
      onClose={onClose}
      visible={viewing}
      destroyOnClose={true}
      bodyStyle={{paddingBottom: 80}}>
      <>
        <Divider>{intl.messages['request']}</Divider>
        <Descriptions bordered size='middle' column={2}>
          <Descriptions.Item label={intl.messages['request.patient']} span={2}>
            {request?.patient?.name} -{' '}
            {request?.patient?.gender
              ? intl.messages[
                  `common.gender.${request?.patient.gender.toLowerCase()}`
                ]
              : ''}{' '}
            - {calculateAge(request?.patient?.birthDate)}{' '}
            {intl.messages['common.age']}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.speciality']}>
            {request?.speciality?.name}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.status']}>
            <Tag color='red'>
              {intl.messages[`request.status.${request?.status.toLowerCase()}`]}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.symptom']} span={2}>
            {request?.symptom}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.note']} span={2}>
            {request?.note}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.requester']}>
            {request?.requester && (
              <Tag color='green'>
                <Link to={`/health/practitioners/${request?.requester.id}`}>
                  {request?.requester.name}
                </Link>
              </Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['request.performer']}
            span={2}>
            {request?.performer && (
              <Tag color='green'>
                <Link to={`/health/organizations/${request?.performer.id}`}>
                  {request?.performer.name}
                </Link>
              </Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.occurrenceDate']}>
            {periodTimeText(
              request?.occurrenceStartTime,
              request?.occurrenceEndTime,
            )}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['request.performanceDate']}
            span={2}>
            {periodTimeText(
              request?.performanceStartTime,
              request?.performanceEndTime,
            )}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['request.location']}>
            {request?.location && (
              <Link to={`/health/locations/${request?.location?.id}`}>
                {request?.location?.name}
              </Link>
            )}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['request.instruction']}
            span={2}>
            {request?.instruction}
          </Descriptions.Item>
        </Descriptions>

        <Divider>{intl.messages['diagnostic']}</Divider>

        <Descriptions bordered size='middle' column={2}>
          <Descriptions.Item
            label={intl.messages['diagnostic.disease']}
            span={2}>
            {request?.diagnostic?.disease?.name}
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.messages['diagnostic.conclusion']}
            span={2}>
            {request?.diagnostic?.conclusion}
          </Descriptions.Item>
          <Descriptions.Item label={intl.messages['diagnostic.note']} span={2}>
            {request?.diagnostic?.note}
          </Descriptions.Item>
        </Descriptions>
      </>
    </Drawer>
  );
};

export default DiagnosticInfo;

DiagnosticInfo.propTypes = {
  request: PropTypes.object,
  viewing: PropTypes.bool.isRequired,
  setViewing: PropTypes.func.isRequired,
};
